import React, { useEffect, useState } from 'react'
import styles from './PriceSetUp.module.css'
import { Button, CircularProgress, InputAdornment } from '@mui/material'
import { CustomTextField, InputPropsForAddAffiliates } from '../../helper';
import { useForm } from 'react-hook-form';
import { useLazyQuery, useMutation } from '@apollo/client';
import { GET_BONUS_AMOUNTS, UPDATE_BONUS_AMOUNTS, UPDATE_QUICK_CUT_AMOUNT } from './api/PriceSetUp';
import ToasterWithMessage from '../../components/shared-components/toaster';

const InputField = CustomTextField();
interface submittedBonusData{
    referralBonus: string,
    affiliateBonus: string,
    cutAmount: string
}
interface propType{
  activeTab: number
}
interface arrayValueType{
  eg_id: string,
  referral_amount: number,
  referral_type: string
}
interface bonusResultType {
  earning_configuration: arrayValueType[]
}
const PriceSetUp = (props:propType) => {
    const {activeTab} = props;
    const {register,handleSubmit,trigger,setValue,watch,formState: {errors}} = useForm(
        {
            defaultValues: {
                referralBonus: '',
                affiliateBonus: '',
                cutAmount: ''
            },
            mode: "onTouched"});
    const [referralBonus, setReferralBonus] = useState<string>("");
    const [affiliateBonus, setAffiliateBonus] = useState<string>("");
    const [cutAmount, setCutAmount] = useState<string>("");
    const [disableBtn,setDisableBtn] = useState<boolean>(true);
    const [zeroValueErrorForAffiliate,setZeroValueErrorForAffiliate] = useState<string>('');
    const [zeroValueErrorForReferral,setZeroValueErrorForReferral] = useState<string>('');
    const [zeroValueErrorForCutAmount,setZeroValueErrorForCutAmount] = useState<string>('');
    const [checkReferralBonus,setCheckReferralBonus] = useState<number>(0);
    const [checkAffiliateBonus,setCheckAffiliateBonus] = useState<number>(0);
    const [checkCutAmount,setCheckCutAmount] = useState<number>(0);
    
    const {error,success} = ToasterWithMessage();
    const [bonusAmounts,setBonusAmounts] = useState<bonusResultType>();

    const onResetBonus = () => {
        setValue('referralBonus',checkReferralBonus?.toString());
        setReferralBonus(checkReferralBonus.toString());
        setValue('affiliateBonus',checkAffiliateBonus?.toString());
        setAffiliateBonus(checkAffiliateBonus.toString());
        setValue('cutAmount',checkCutAmount?.toString());
        setCutAmount(checkCutAmount.toString());
        setDisableBtn(true);
        trigger("affiliateBonus");
        trigger("referralBonus");
        trigger("cutAmount");
    }

    // const handleOnKeyDownReferral = (e :any) =>{
    //     if(e.key === 'Backspace'){
    //       if(referralBonus.length === 1){
    //         setReferralBonus('');
    //       }
    //     }
    //   }

    // const handleOnKeyDownAffiliate = (e: any) => {
    //     if(e.key === 'Backspace'){
    //         if(affiliateBonus.length === 1){
    //             setAffiliateBonus('');
    //         }
    //     }
    // }

    const handleOnKeyDownCutAmount = (e: any) => {
      if(e.key === 'Backspace'){
          if(cutAmount.length === 1){
              setAffiliateBonus('');
          }
      }
  }

    const handleSubmitBonus = (data: submittedBonusData) => {
        if(data){
          updateBonusAmounts({
            variables: {
              // userReferralBonus: data?.referralBonus,
              // affiliateReferralBonus: data?.affiliateBonus,
              quickCutAmount: data?.cutAmount
            }
          })
        }
    }


    // const handleChangeReferralBonus = (e: React.ChangeEvent<HTMLInputElement>) => {
    //     const input = e.target.value;
    //     setZeroValueErrorForReferral('');
    //     const regexPattern = /^(0|[1-9]\d*)(\.\d{0,2})?$/;
    //     if(input.length > 0){
    //         if(parseInt(input) === 0){
    //         }else {
    //                     if (regexPattern.test(input)) {
    //                         if (parseFloat(input) <= 100000 && parseFloat(input) >= 0) {
    //                         setValue("referralBonus", input);
    //                         setReferralBonus(input);
    //                         trigger("referralBonus");
    //                         }
    //                     } else {
    //                     setReferralBonus(referralBonus);
    //                     }
    //         }
    //     }else {  
    //         trigger("referralBonus");
    //         setReferralBonus('');
    //     }
    // }

    // const handleChangeAffiliateBonus = (e: React.ChangeEvent<HTMLInputElement>) => {
    //     const inputvalue = e.target.value;
    //     setZeroValueErrorForAffiliate('');
    //     const regexPattern = /^(0|[1-9]\d*)(\.\d{0,2})?$/;
    //     if(inputvalue.length > 0){
    //         if(parseInt(inputvalue) === 0){
    //         }else {
    //             if (regexPattern.test(inputvalue)) {
    //                 if (parseFloat(inputvalue) <= 100000 && parseFloat(inputvalue) >= 0) {
    //                   setValue("affiliateBonus", inputvalue);
    //                   setAffiliateBonus(inputvalue);
    //                   trigger("affiliateBonus");
    //                 }
    //               } else {
    //                   setAffiliateBonus(affiliateBonus);
    //               }
    //         }
    //     }else {
    //         trigger("affiliateBonus");
    //         setAffiliateBonus('');
    //     }
    // }


    const handleChangeCutAmount = (e: React.ChangeEvent<HTMLInputElement>) => {
      const inputData = e.target.value;
      setZeroValueErrorForCutAmount('');
      const regexPattern = /^(0|[1-9]\d*)(\.\d{0,2})?$/;
      if(inputData.length > 0){
          if(parseInt(inputData) === 0){
          }else {
                      if (regexPattern.test(inputData)) {
                          if (parseFloat(inputData) <= 50 && parseFloat(inputData) >= 0) {
                          setValue("cutAmount", inputData);
                          setCutAmount(inputData);
                          trigger("cutAmount");
                          }
                      } else {
                      setCutAmount(cutAmount);
                      }
          }
      }else {  
          trigger("cutAmount");
          setCutAmount('');
      }
  }

    useEffect(() => {
        if((parseFloat(watch('referralBonus')) === checkReferralBonus) &&
           (parseFloat(watch('affiliateBonus')) === checkAffiliateBonus) &&
           (parseFloat(watch("cutAmount")) === checkCutAmount) 
          ){
            setDisableBtn(true);
        }else {
            setDisableBtn(false);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[watch('referralBonus'),watch('affiliateBonus'),watch('cutAmount')])

    const [getBonusAmounts,{loading}] = useLazyQuery(GET_BONUS_AMOUNTS,{
      fetchPolicy: 'no-cache',
      onCompleted: (data) => {
        setBonusAmounts(data);
        // eslint-disable-next-line array-callback-return
        data?.earning_configuration.map((value : arrayValueType) => {
            if(value?.referral_type === 'user'){
              setValue('referralBonus',value?.referral_amount.toString());
              setReferralBonus(value?.referral_amount.toString());
              setCheckReferralBonus(value?.referral_amount);
            }else if(value?.referral_type === 'affiliate'){
              setValue("affiliateBonus",value?.referral_amount.toString());
              setAffiliateBonus(value?.referral_amount.toString());
              setCheckAffiliateBonus(value?.referral_amount);
            }else{
              setValue("cutAmount",value?.referral_amount.toString());
              setCutAmount(value?.referral_amount.toString());
              setCheckCutAmount(value?.referral_amount);
            }
        })
      }
    });

    const [updateBonusAmounts] = useMutation(UPDATE_QUICK_CUT_AMOUNT,{
      fetchPolicy: 'no-cache',
      onCompleted: () => {
        getBonusAmounts();
        success("Updated successfully");
        setDisableBtn(true);
      },
      onError: () => {
        error("Something went wrong while updating!");
      }
    });

    useEffect(() => {
      if(activeTab === 1){
          getBonusAmounts();
      }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[activeTab]);

  return (
    <>
    { loading 
    ? 
    <div className={styles.circularProgress}>
      <CircularProgress color="primary" size={35}/>
    </div>
    :
    <form onSubmit={handleSubmit(handleSubmitBonus)} style={{ width: "100%" }}>
        <div className={styles.mainContainer}>
          <div className={styles.secondaryContainer}>
            <div className={styles.bonusFieldContainer}>
            {/* <span className={styles.referFriendInputStyle}>
                <div className={styles.titlePlaceholderReferral}>
                     <div className={styles.referralBonusAmount}>Referral Bonus</div>
                </div>
                <InputField 
                    variant="outlined"
                    data-testid='referralbonus'
                    fullWidth
                    {...register("referralBonus",{
                    required: "Referral bonus is required!"
                    })}
                    value={referralBonus}
                    placeholder={'Enter Referral Bonus'}
                    InputProps={{
                        style: InputPropsForAddAffiliates,
                        startAdornment: (
                            <InputAdornment position="start">
                              {`$`}
                            </InputAdornment>
                          )
                    }}
                    error={Boolean(errors?.referralBonus?.message) || Boolean(zeroValueErrorForReferral)}
                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleChangeReferralBonus(e)}
                    onKeyDown={handleOnKeyDownReferral}
                    />
                <span className={styles.errorMsgStyle}>{zeroValueErrorForReferral || errors?.referralBonus?.message}</span>
            </span>
            <span className={styles.affiliateInputStyle}>
                <div className={styles.titlePlaceholderAffiliate}>
                     <div className={styles.affiliateBonusAmount}>Affiliate Bonus</div>
                </div>
                <InputField 
                    variant="outlined"
                    data-testid='affiliatebonus'
                    fullWidth
                    {...register("affiliateBonus",{
                    required: "Affiliate bonus is required!"
                    })}
                    value={affiliateBonus}
                    placeholder={'Enter Affiliate Bonus'}
                    InputProps={{
                        style: InputPropsForAddAffiliates,
                        startAdornment: (
                            <InputAdornment position="start">
                              {`$`}
                            </InputAdornment>
                          )
                    }}
                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleChangeAffiliateBonus(e)}
                    onKeyDown={handleOnKeyDownAffiliate}
                    error={Boolean(errors?.affiliateBonus?.message) || Boolean(zeroValueErrorForAffiliate)}
                    />
                <span className={styles.errorMsgStyle}>{zeroValueErrorForAffiliate || errors?.affiliateBonus?.message}</span>
            </span> */}
            <span className={styles.cutAmountInputStyle}>
                <div className={styles.titlePlaceholderCutAmount}>
                     <div className={styles.quickCutAmount}>QuickAsyst Fee</div>
                </div>
                <InputField 
                    variant="outlined"
                    data-testid='cutAmount'
                    fullWidth
                    {...register("cutAmount",{
                    required: "Cut Amount is required!"
                    })}
                    value={cutAmount}
                    placeholder={'Enter cut amount'}
                    InputProps={{
                        style: InputPropsForAddAffiliates,
                        endAdornment: (
                          <InputAdornment position="start">
                            {`%`}
                          </InputAdornment>
                        )
                    }}
                    error={Boolean(errors?.cutAmount?.message) || Boolean(zeroValueErrorForCutAmount)}
                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleChangeCutAmount(e)}
                    onKeyDown={handleOnKeyDownCutAmount}
                    />
                <span className={styles.errorMsgStyle}>{zeroValueErrorForCutAmount || errors?.cutAmount?.message}</span>
            </span>
            </div>
          </div>
        </div>
        <div className={styles.ctaContainer}>
          <div className={styles.buttonStyle} onClick={onResetBonus}>
            <Button
              classes={{ root: styles.separateStyleforcancelReferral }}
              fullWidth
              disableRipple
            >
              Reset
            </Button>
          </div>
          <div
            className={disableBtn ? styles.disabledButton : styles.updateButtonStyle}
          >
            <Button
              classes={{
                 root : disableBtn 
                        ? styles.separateStyledisabledUpdateBtn 
                        : styles.separateStyleReferral
              }}
              disableRipple
              fullWidth
              type="submit"
              disabled={disableBtn}
            >
              Update
            </Button>
          </div>
        </div>
    </form>
    } 
   </>
  )
}

export default PriceSetUp